import { useAppDispatch } from 'store/hooks';
import React from 'react';
import {
    toggleCreateModal,
    toggleCloseCreateModal,
    toggleCloseUpdateModal,
    closeModals,
    setItemToReset,
    setPerkAwardCount,
    setItemToDelete
} from 'store/perks/perksSlice';

export const usePepperPerksModals = () => {
    const dispatch = useAppDispatch();

    const handleToggleCreateModal = React.useCallback(() => dispatch(toggleCreateModal()), [dispatch]);

    const handleToggleCloseCreateModal = React.useCallback(() => {
        dispatch(toggleCloseCreateModal());
    }, [dispatch]);

    const handleToggleUpdateCreateModal = React.useCallback(
        () => dispatch(toggleCloseUpdateModal()),
        [dispatch]
    );

    const handleCloseModals = React.useCallback(() => {
        dispatch(closeModals());
    }, [dispatch]);

    const closeResetPopUp = React.useCallback(() => {
        dispatch(setItemToReset(-1));
        dispatch(setPerkAwardCount(-1));
    }, [dispatch]);

    const closeDeletePopUp = React.useCallback(() => {
        dispatch(setItemToDelete(-1));
    }, [dispatch]);

    return {
        toggleCreateModal: handleToggleCreateModal,
        toggleCloseCreateModal: handleToggleCloseCreateModal,
        toggleUpdateCreateModal: handleToggleUpdateCreateModal,
        closeModals: handleCloseModals,
        closeResetPopUp,
        closeDeletePopUp
    };
};
